(() => {
  const root = document.querySelector('[data-convention-order]');
  if (!root) return;
  const announcementBar = document.querySelector('.shopify-section-group-header-group slideshow-component.announcement-bar');
  if (announcementBar && typeof announcementBar.pause === 'function') announcementBar.pause();
  const view = root.querySelector('[data-order-view]');
  const fastCatalogEndpoint = 'https://libero-convention-order-proxy.libero-animestore.workers.dev/catalog';
  const catalogEndpoint = root.dataset.catalogEndpoint && !root.dataset.catalogEndpoint.includes('/apps/convention-order/catalog')
    ? root.dataset.catalogEndpoint
    : fastCatalogEndpoint;
  const turnstileSitekey = '0x4AAAAAAEji7OxOc8UBOrSl';
  const turnstileLoadTimeoutMs = 15000;
  const turnstileWatchdogTimeoutMs = 20000;
  const catalogTimeoutMs = 20000;
  const submitTimeoutMs = 70000;
  let turnstileApiPromise;
  let turnstileWidgetId = null;
  let turnstileWatchdogId = null;
  let turnstileAttempt = 0;
  let pendingSubmissionForm = null;
  let pendingOrderRequest = null;
  let submissionInFlight = false;
  let submissionUncertain = false;
  let retryingUncertainSubmission = false;
  let submissionComplete = false;
  let submissionId = '';
  let submissionSignature = '';
  let shippingDraft = null;
  const state = {
    step: 1, game: '', productType: '', items: [], catalog: [], catalogLoading: true, catalogError: false,
    selectedItemKeys: [], pendingItems: [], selectedSize: '', cartReturnStep: 4
  };
  const games = [
    ['GI', 'Genshin Impact'], ['SR', 'Honkai: Star Rail'], ['ZZ', 'Zenless Zone Zero'], ['LD', 'Love and Deepspace'],
    ['WW', 'Wuthering Waves'], ['AF', 'Anime'], ['VT', 'Vtuber'], ['NA', 'Other']
  ];
  const products = ['Body Pillow Cover', 'Deskmat', 'Body Pillow Filling'];
  const sizeOptions = {
    'Body Pillow Cover': [
      { value: '50 cm x 150 cm / 20" x 59"', default: true },
      { value: '50 cm x 160 cm / 20" x 63"' },
      { value: '60 cm x 180 cm / 24" x 71"' }
    ],
    Deskmat: [
      { value: '15.7 x 26.8" / 40 x 68 cm', default: true },
      { value: '8.3 x 10.2" / 21 x 26 cm' },
      { value: '15.7 x 35.4" / 40 x 90 cm' }
    ]
  };
  const sizePriceNote = value => {
    const text = String(value || '').replace(/\s+/g, ' ').trim();
    if (/^50\s*(?:cm\s*)?[×x]\s*160\s*cm/i.test(text)) return '+ 10$';
    if (/^60\s*(?:cm\s*)?[×x]\s*180\s*cm/i.test(text)) return '+ 50$';
    return '';
  };
  const fallbackCountries = [
    'United States', 'Canada', 'Australia', 'United Kingdom', 'Singapore', 'Malaysia', 'Thailand', 'Philippines', 'Indonesia', 'Vietnam',
    'Japan', 'South Korea', 'China', 'Hong Kong SAR', 'Taiwan', 'Macau SAR', 'India', 'New Zealand', 'Mexico', 'Brazil',
    'Germany', 'France', 'Italy', 'Spain', 'Netherlands', 'Belgium', 'Switzerland', 'Austria', 'Sweden', 'Norway',
    'Denmark', 'Finland', 'Ireland', 'Portugal', 'Poland', 'Czechia', 'Greece', 'Turkey', 'Israel', 'United Arab Emirates',
    'Saudi Arabia', 'Qatar', 'Kuwait', 'South Africa', 'Egypt', 'Morocco', 'Argentina', 'Chile', 'Colombia', 'Peru',
    'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Armenia', 'Aruba', 'Azerbaijan',
    'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia & Herzegovina',
    'Botswana', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Chad',
    'Cook Islands', 'Costa Rica', 'Croatia', 'Curaçao', 'Cyprus', 'Dominica', 'Dominican Republic', 'Ecuador', 'El Salvador', 'Estonia',
    'Fiji', 'French Polynesia', 'Georgia', 'Ghana', 'Gibraltar', 'Greenland', 'Grenada', 'Guadeloupe', 'Guatemala', 'Guernsey',
    'Guyana', 'Honduras', 'Hungary', 'Iceland', 'Iraq', 'Isle of Man', 'Jamaica', 'Jersey', 'Jordan', 'Kazakhstan',
    'Kenya', 'Kosovo', 'Laos', 'Latvia', 'Lebanon', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Maldives', 'Malta',
    'Martinique', 'Mauritius', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Mozambique', 'Namibia', 'Nepal',
    'New Caledonia', 'Nicaragua', 'Nigeria', 'North Macedonia', 'Oman', 'Pakistan', 'Panama', 'Paraguay', 'Réunion', 'Romania',
    'Rwanda', 'Samoa', 'San Marino', 'Senegal', 'Serbia', 'Seychelles', 'Slovakia', 'Slovenia', 'Sri Lanka', 'St. Kitts & Nevis',
    'St. Lucia', 'St. Vincent & Grenadines', 'Suriname', 'Tanzania', 'Trinidad & Tobago', 'Tunisia', 'Turks & Caicos Islands', 'Uganda', 'Ukraine', 'Uruguay',
    'Uzbekistan', 'Vatican City', 'Venezuela', 'Zambia', 'Zimbabwe'
  ];
  const gameIcons = {
    GI: '<svg viewBox="0 0 220 70" aria-hidden="true"><text x="110" y="33" text-anchor="middle" font-size="27" font-family="Georgia,serif" font-weight="700">GENSHIN</text><text x="110" y="54" text-anchor="middle" font-size="14" font-family="Georgia,serif" letter-spacing="6">IMPACT</text><path d="M110 4l7 16 17 2-13 11 4 17-15-9-15 9 4-17-13-11 17-2z" fill="none"/></svg>',
    SR: '<svg viewBox="0 0 220 70" aria-hidden="true"><text x="110" y="32" text-anchor="middle" font-size="20" font-family="Georgia,serif" font-style="italic">Honkai</text><text x="110" y="55" text-anchor="middle" font-size="27" font-family="Arial,sans-serif" font-weight="800" font-style="italic">STAR RAIL</text><path d="M154 10c22 12 25 35 4 50M60 48c33-19 68-23 106-13" fill="none"/></svg>',
    ZZ: '<svg viewBox="0 0 220 70" aria-hidden="true"><text x="110" y="43" text-anchor="middle" font-size="34" font-family="Arial Black,Arial,sans-serif" font-weight="900">Z·Z·Z</text><text x="110" y="61" text-anchor="middle" font-size="9" font-family="Arial,sans-serif" letter-spacing="2">ZENLESS ZONE ZERO</text></svg>',
    LD: '<svg viewBox="0 0 220 70" aria-hidden="true"><text x="110" y="35" text-anchor="middle" font-size="31" font-family="Georgia,serif" font-style="italic">Love</text><text x="110" y="56" text-anchor="middle" font-size="13" font-family="Georgia,serif" letter-spacing="5">AND DEEPSPACE</text><path d="M148 18h16M156 10v16" fill="none"/></svg>',
    WW: '<svg viewBox="0 0 220 70" aria-hidden="true"><text x="110" y="32" text-anchor="middle" font-size="25" font-family="Arial Black,Arial,sans-serif" font-weight="900">WUTHERING</text><text x="110" y="58" text-anchor="middle" font-size="25" font-family="Arial Black,Arial,sans-serif" font-weight="900">WAVES</text></svg>',
    AF: '<svg viewBox="0 0 140 70" aria-hidden="true"><path d="M27 36c16-24 70-24 86 0-16 24-70 24-86 0z" fill="none"/><circle cx="70" cy="36" r="15" fill="none"/><circle cx="70" cy="36" r="6"/><path d="M31 24c10-7 23-12 39-12 17 0 31 5 40 13M34 48c11 8 23 11 36 11 15 0 27-4 37-11" fill="none"/></svg>',
    VT: '<svg viewBox="0 0 140 70" aria-hidden="true"><rect x="45" y="22" width="50" height="38" rx="12" fill="none"/><path d="M60 22l-8-12M80 22l8-12"/><circle cx="61" cy="42" r="4"/><circle cx="79" cy="42" r="4"/><path d="M63 51c5 4 10 4 15 0"/></svg>',
    NA: '<svg viewBox="0 0 140 70" aria-hidden="true"><circle cx="52" cy="35" r="7"/><circle cx="70" cy="35" r="7"/><circle cx="88" cy="35" r="7"/></svg>'
  };
  const productIcons = {
    'Body Pillow Cover': '<svg viewBox="0 0 140 86" aria-hidden="true"><path d="M50 8c15 5 25 5 40 0 8 23 8 47 0 70-15-5-25-5-40 0-8-23-8-47 0-70z" fill="none"/><path d="M70 23c-8 0-13 7-9 14 2 3 4 5 5 8l-8 18M74 45l8 18M59 49h22"/></svg>',
    Deskmat: '<svg viewBox="0 0 140 86" aria-hidden="true"><rect x="20" y="25" width="100" height="42" rx="6" fill="none"/><path d="M30 33c26 5 54 5 80 0M32 58c24-5 51-5 76 0"/><path d="M70 34l6 12 13 2-9 8 2 13-12-6-12 6 2-13-9-8 13-2z"/></svg>',
    'Body Pillow Filling': '<svg viewBox="0 0 140 86" aria-hidden="true"><path d="M12 34c25-8 91-8 116 0 4 8 4 11 0 19-25 8-91 8-116 0-4-8-4-11 0-19z" fill="none"/><path d="M22 36c21 4 74 4 96 0M22 51c21-4 74-4 96 0"/></svg>'
  };
  const esc = value => String(value || '').replace(/[&<>'"]/g, char => ({ '&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;' }[char]));
  const createSubmissionId = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    if (!window.crypto || typeof window.crypto.getRandomValues !== 'function') throw new Error('Secure submission ID unavailable');
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  };
  const withTimeout = (promise, timeoutMs, message) => {
    let timer = null;
    const timeout = new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error(message)), timeoutMs);
    });
    return Promise.race([promise, timeout]).finally(() => {
      if (timer !== null && typeof clearTimeout === 'function') clearTimeout(timer);
    });
  };
  const fetchResponseWithTimeout = async (endpoint, options, timeoutMs) => {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const requestOptions = Object.assign({}, options);
    if (controller) requestOptions.signal = controller.signal;
    let timer = null;
    const timeout = new Promise((_, reject) => {
      timer = setTimeout(() => {
        if (controller) controller.abort();
        reject(new Error('Submission response timed out.'));
      }, timeoutMs);
    });
    try {
      return await Promise.race([
        fetch(endpoint, requestOptions).then(async response => ({ response, text: await response.text() })),
        timeout,
      ]);
    } finally {
      if (timer !== null && typeof clearTimeout === 'function') clearTimeout(timer);
    }
  };
  const loadTurnstile = () => {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (turnstileApiPromise) return turnstileApiPromise;
    turnstileApiPromise = withTimeout(new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.onload = () => window.turnstile ? resolve(window.turnstile) : reject(new Error('Turnstile unavailable'));
      script.onerror = () => reject(new Error('Turnstile unavailable'));
      document.head.appendChild(script);
    }), turnstileLoadTimeoutMs, 'Turnstile load timed out.').catch(error => { turnstileApiPromise = undefined; throw error; });
    return turnstileApiPromise;
  };
  // Catalog identity is kept unchanged for the backend; customer-facing names use
  // the English part only. This prevents imported Chinese source labels appearing
  // in the storefront without guessing translations.
  const englishOnly = value => String(value || '')
    .replace(/（[^）]*）/g, ' ')
    .replace(/[\u3400-\u9fff\uf900-\ufaff]/g, ' ')
    .replace(/[（），、：]/g, ' ')
    .replace(/[\r\n]+/g, ' ')
    .replace(/\s*[-–—]\s*(?=[-–—]|$)/g, ' ')
    .replace(/^\s*[·•.。,:：、，]+\s*/g, '')
    .replace(/^\s*[-–—]\s*/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  // During the catalog label migration, accept either known Wuthering spelling.
  // This keeps availability correct for clients still using an older cached asset.
  const catalogGameNames = game => game === 'Wuthering Waves' ? ['Wuthering Waves', 'Wuthering Wave'] : [game];
  const matchesSelectedGame = item => catalogGameNames(state.game).includes(item.game);
  const validCatalogKey = value => {
    const text = String(value == null ? '' : value).trim();
    return text.length > 0 && text.length <= 240 && !/[\u0000-\u001F\u007F]/.test(text);
  };
  const validCatalogCode = value => /^[A-Za-z0-9][A-Za-z0-9._-]{2,80}$/.test(String(value || '').trim());
  const validImageUrl = value => /^https:\/\/[^\s<>"']+$/i.test(String(value || '').trim());
  const normalizeImageEntries = row => {
    const rawEntries = Array.isArray(row.images) ? row.images : [];
    const entries = rawEntries.map(entry => {
      if (typeof entry === 'string') return { url: entry.trim(), label: '' };
      if (!entry || typeof entry !== 'object') return null;
      return { url: String(entry.url || entry.src || '').trim(), label: String(entry.label || entry.side || '').trim() };
    }).filter(entry => entry && validImageUrl(entry.url) && entry.label.length <= 80);
    const legacyUrl = String(row.image || row.imageUrl || '').trim();
    if (validImageUrl(legacyUrl)) {
      const existing = entries.find(entry => entry.url === legacyUrl);
      return [{ url: legacyUrl, label: existing ? existing.label : '' }, ...entries.filter(entry => entry.url !== legacyUrl)].slice(0, 8);
    }
    return entries.slice(0, 8);
  };
  const normalize = rows => rows.map(row => {
    const images = normalizeImageEntries(row);
    return { key: row.key || row.catalogKey, game: row.game, ip: row.ip, type: row.type, label: row.label || row.type, character: row.character, fullCode: row.fullCode, material: row.material, size: row.size, image: images[0] ? images[0].url : '', images };
  })
    .filter(item => validCatalogKey(item.key) && validCatalogCode(item.fullCode) && item.game && item.type && item.label && item.character);
  const setProgress = () => {
    const visibleStep = Math.min(state.step, 5);
    root.querySelectorAll('[data-progress]').forEach(node => {
      const value = Number(node.dataset.progress);
      node.classList.toggle('is-active', value === visibleStep);
      node.classList.toggle('is-complete', value < visibleStep);
    });
  };
  const imageWidths = [180, 320, 560, 840];
  const resizableImageHost = url => {
    try {
      const hostname = new URL(url, window.location.origin).hostname;
      return hostname.includes('cdn.shopify.com') || hostname.includes('liberoanime.com');
    } catch (_) { return false; }
  };
  const imageUrl = (url, width = 320) => {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      if (resizableImageHost(url)) {
        parsed.searchParams.set('width', String(width));
      }
      return parsed.toString();
    } catch (_) {
      return url;
    }
  };
  const imageCandidates = url => {
    if (!url) return [];
    if (!resizableImageHost(url)) return [imageUrl(url)];
    return [...new Set(imageWidths.map(width => imageUrl(url, width)))];
  };
  const imageTag = (url, alt, cls = '', width = 320, loading = 'lazy', sizes = '320px') => {
    const candidates = imageCandidates(url);
    const firstLargerIndex = imageWidths.findIndex(candidateWidth => candidateWidth >= width);
    const preferredIndex = candidates.length > 1 ? (firstLargerIndex < 0 ? candidates.length - 1 : firstLargerIndex) : 0;
    const src = candidates[preferredIndex] || candidates[0] || '';
    const fallback = candidates.slice(preferredIndex + 1)[0] || '';
    if (!src) return `<div class="${cls} co-image-missing" aria-hidden="true">Image unavailable</div>`;
    const srcset = candidates.length > 1 ? ` srcset="${esc(candidates.map((candidate, index) => `${candidate} ${imageWidths[index]}w`).join(', '))}"` : '';
    const fallbackAttribute = fallback ? ` data-fallback-src="${esc(fallback)}"` : '';
    return `<img class="${cls}" src="${esc(src)}"${srcset} sizes="${esc(sizes)}"${fallbackAttribute} data-fallback-label="${esc(alt)}" alt="${esc(alt)}" loading="${loading}" decoding="async" fetchpriority="${loading === 'eager' ? 'high' : 'low'}">`;
  };
  const designImageSizes = '(max-width: 640px) calc(50vw - 24px), min(50vw, 320px)';
  const image = (item, cls = '', width = 320, loading = 'lazy', sizes = designImageSizes) => imageTag(item.image, englishOnly(item.character) || item.label, cls, width, loading, sizes);
  const imageEntries = item => Array.isArray(item.images) && item.images.length ? item.images : (item.image ? [{ url: item.image, label: '' }] : []);
  const imageGallery = (item, cls = '', width = 320, loading = 'lazy', sizes = designImageSizes) => {
    const entries = imageEntries(item);
    if (entries.length < 2) return image(item, cls, width, loading, sizes);
    const altBase = englishOnly(item.character) || item.label;
    return `<span class="co-image-gallery ${cls}" role="group" aria-label="${esc(altBase)} previews">${entries.map((entry, index) => {
      const label = entry.label || (index === 0 ? 'A' : index === 1 ? 'B' : `View ${index + 1}`);
      return `<span class="co-image-panel">${imageTag(entry.url, `${altBase} ${label}`, 'co-gallery-image', width, loading, sizes)}<small>${esc(label)}</small></span>`;
    }).join('')}</span>`;
  };
  const productPreview = type => {
    const candidates = state.catalog.filter(item => matchesSelectedGame(item) && item.type === type && item.image);
    const preferred = candidates.find(item => /^a/i.test(String(item.character || '').trim())) || candidates[0];
    return preferred
      ? imageTag(preferred.image, `${type} preview${preferred.character ? ` - ${englishOnly(preferred.character)}` : ''}`, 'co-product-photo', 120, 'eager', '92px')
      : `<span class="co-icon co-product-icon">${productIcons[type]}</span>`;
  };
  const hasCatalogItems = type => state.catalog.some(item => matchesSelectedGame(item) && item.type === type);
  const visibleProducts = () => state.catalogLoading ? (state.catalog.length ? products.filter(hasCatalogItems) : products) : state.catalogError ? [] : products.filter(hasCatalogItems);
  const button = (label, action, disabled = false) => `<button type="button" class="co-button" data-action="${action}" ${disabled ? 'disabled' : ''}>${label}</button>`;
  const backButton = () => '<button type="button" class="co-button co-back-button" data-action="back">Back</button>';
  const cartButton = () => state.items.length ? '<button type="button" class="co-button co-back-button" data-action="view-cart">View current order</button>' : '';
  const stickyActions = (primary, secondary = '') => `<div class="co-sticky-actions">${secondary}${primary}</div>`;
  const priorityCountries = ['Canada', 'United States', 'United Kingdom', 'Germany', 'France', 'Australia', 'New Zealand', 'Singapore'];
  const countryOptions = () => {
    return `<option value="">Country / Region</option>${priorityCountries.map(country => `<option>${esc(country)}</option>`).join('')}<option value="Other">Other</option>`;
  };
  const selected = (value, current) => value === current ? ' is-selected' : '';
  const cartItemLabel = item => {
    const label = String(item.label || item.type || '').trim();
    return item.type === 'Body Pillow Cover'
      ? label.replace(/\s*\/\s*50\s*[×x]\s*150\s*cm\s*$/i, '').trim()
      : label;
  };
  const needsSizeSelection = () => Boolean(sizeOptions[state.productType]);
  const selectedDesignItems = () => state.selectedItemKeys.map(key => availableItems().find(item => item.key === key)).filter(Boolean);
  const addItemsToOrder = (items, size = '') => {
    state.items.push(...items.map(item => Object.assign({}, item, size ? { size } : {})));
  };
  const logoDatasetKeys = { GI: 'logoGi', SR: 'logoSr', ZZ: 'logoZz', LD: 'logoLd', WW: 'logoWw', AF: 'logoAf' };
  const gameIcon = (code, name) => {
    const logoUrl = root.dataset[logoDatasetKeys[code]];
    if (logoUrl) return `<img class="co-game-logo" src="${esc(logoUrl)}" alt="${esc(name)} logo" loading="eager" decoding="async" fetchpriority="high">`;
    return gameIcons[code] || `<span class="co-wordmark">${esc(name)}</span>`;
  };
  const renderGames = () => `<div class="co-view co-has-sticky"><p class="co-kicker">Step 1 of 5</p><h2 class="co-title">Choose your game</h2><div class="co-grid">${games.map(([code, name]) => `<button class="co-choice co-game-choice${selected(name, state.game)}" data-game="${name}"><span class="co-icon">${gameIcon(code, name)}</span><strong>${name}</strong></button>`).join('')}</div>${cartButton()}<p class="co-helper">You will choose your product next.</p>${stickyActions(button('Continue', 'continue-game', !state.game))}</div>`;
  const productContinueDisabled = () => !state.productType || !visibleProducts().includes(state.productType) || state.catalogLoading || state.catalogError;
  const catalogRetry = () => state.catalogError ? `<p class="co-status" role="alert">We couldn't load the product catalog. Your current selections are kept. Please try again.</p>${button('Retry loading catalog', 'retry-catalog')}` : '';
  const renderProducts = () => `<div class="co-view co-has-sticky"><p class="co-kicker">Step 2 of 5</p><h2 class="co-title">Choose your item</h2><p class="co-helper">${esc(state.game)}</p>${state.catalogLoading ? '<p class="co-loading-note" role="status">Loading product catalog…</p>' : catalogRetry()}<div class="co-grid">${visibleProducts().map(type => `<button type="button" class="co-choice co-product-choice${selected(type, state.productType)}" data-product="${type}">${productPreview(type)}<strong>${type}</strong></button>`).join('')}</div>${cartButton()}${stickyActions(button('Continue', 'continue-product', productContinueDisabled()), backButton())}</div>`;
  const availableItems = () => state.catalog.filter(item => matchesSelectedGame(item) && item.type === state.productType);
  const renderDesigns = () => {
    const items = availableItems();
    if (state.catalogLoading) return `<div class="co-view co-has-sticky"><p class="co-kicker">Step 3 of 5</p><h2 class="co-title">Loading products…</h2><p class="co-helper">Please wait a moment while the product catalog loads.</p>${cartButton()}${stickyActions('', backButton())}</div>`;
    if (state.catalogError) return `<div class="co-view co-has-sticky"><p class="co-kicker">Step 3 of 5</p><h2 class="co-title">Products unavailable</h2>${catalogRetry()}${cartButton()}${stickyActions('', backButton())}</div>`;
    const primaryAction = needsSizeSelection() ? 'continue-size' : 'add-selected';
    const primaryLabel = needsSizeSelection() ? 'Continue to size' : 'Add selected to order';
    return `<div class="co-view co-has-sticky"><p class="co-kicker">Step 3 of 5</p><h2 class="co-title">Choose your ${esc(state.productType)}</h2><p class="co-helper">${esc(state.game)}</p>${items.length ? `<div class="co-grid co-design-grid">${items.map((item, index) => { const note = sizePriceNote(item.size); return `<button type="button" class="co-choice co-design${state.selectedItemKeys.includes(item.key) ? ' is-selected' : ''}" data-item="${esc(item.key)}">${imageGallery(item, '', index < 4 ? 180 : 160, index < 4 ? 'eager' : 'lazy')}<strong>${esc(englishOnly(item.character) || item.label)}</strong>${note ? `<small class="co-price-note">${esc(note)}</small>` : ''}</button>`; }).join('')}</div>` : `<p class="co-empty">No active designs are available for this selection yet.</p>`}${cartButton()}${stickyActions(items.length ? button(primaryLabel, primaryAction, !state.selectedItemKeys.length) : '', backButton())}</div>`;
  };
  const renderSize = () => {
    const options = sizeOptions[state.productType] || [];
    return `<div class="co-view co-has-sticky"><p class="co-kicker">Step 4 of 5</p><h2 class="co-title">Choose your size</h2><p class="co-helper">${esc(state.productType)} - ${esc(state.game)}</p><div class="co-size-grid">${options.map(option => { const note = sizePriceNote(option.value); return `<button type="button" class="co-choice co-size-choice${selected(option.value, state.selectedSize)}" data-size="${esc(option.value)}"><strong>${esc(option.value)}</strong>${note ? `<small class="co-price-note">${esc(note)}</small>` : ''}${option.default ? '<small>Default</small>' : ''}</button>`; }).join('')}</div>${cartButton()}${stickyActions(button('Add to order', 'add-sized', !state.selectedSize || !state.pendingItems.length), backButton())}</div>`;
  };
  const renderCart = () => `<div class="co-view co-has-sticky"><p class="co-kicker">Step 5 of 5</p><h2 class="co-title">Your Convention Order</h2><div class="co-cart">${state.items.map((item, index) => `<div class="co-cart-row">${imageGallery(item, '', 96, 'lazy', '58px')}<span><strong>${esc(cartItemLabel(item))}</strong><br>${esc(englishOnly(item.character) || item.size)}${item.size ? `<small>${esc(item.size)}</small>` : ''}</span><button data-remove="${index}" aria-label="Remove item">Remove</button></div>`).join('')}</div><div class="co-actions"><button class="co-text-button" data-action="add-more">＋ Add another item</button></div>${stickyActions(button('Continue to shipping details', 'shipping', !state.items.length), backButton())}</div>`;
  const renderShipping = () => `<div class="co-view co-has-sticky"><h2 class="co-title">Shipping details</h2><form class="co-form" data-shipping-form>
    <label class="co-full"><span>Full name</span><input name="name" autocomplete="name" required></label>
    <label><span>Email address</span><input name="email" type="email" autocomplete="email" required></label>
    <label><span>Phone number</span><input name="phone" type="tel" autocomplete="tel" required></label>
    <label class="co-full"><span>Country / Region</span><select name="country" autocomplete="country-name" required>${countryOptions()}</select></label>
    <label class="co-full" data-country-other-label hidden><span>Country / Region name</span><input name="countryOther" autocomplete="country-name" data-country-other hidden></label>
    <label class="co-full"><span>Address line 1</span><input name="address1" autocomplete="address-line1" required></label>
    <label class="co-full"><span>Address line 2 (optional)</span><input name="address2" autocomplete="address-line2"></label>
    <label><span>City</span><input name="city" autocomplete="address-level2" required></label>
    <label><span>State / Province (optional)</span><input name="state" autocomplete="address-level1"></label>
    <label><span>Zip Code / Postal Code (optional)</span><input name="postalCode" autocomplete="postal-code"></label>
    <div class="co-full" data-turnstile-widget></div><p class="co-helper co-full" data-turnstile-status hidden></p></form>${stickyActions(button('Submit Convention Order', 'submit'), backButton())}</div>`;
  const updateCountryOther = () => {
    const select = view.querySelector('select[name="country"]');
    const input = view.querySelector('[data-country-other]');
    if (!select || !input) return;
    const show = select.value === 'Other';
    input.hidden = !show;
    input.closest('label').hidden = !show;
    input.required = show;
    if (!show) input.value = '';
  };
  const showImageFallback = img => {
    const fallback = document.createElement('div');
    fallback.className = `${img.className} co-image-missing`;
    fallback.textContent = img.dataset.fallbackLabel || 'Image unavailable';
    img.replaceWith(fallback);
  };
  const tryImageFallback = img => {
    if (!(img instanceof HTMLImageElement) || !img.dataset.fallbackSrc || (img.complete && img.naturalWidth > 0)) return;
    if (!img.dataset.fallbackUsed && img.dataset.fallbackSrc !== img.src) {
      img.dataset.fallbackUsed = 'true';
      if (typeof img.removeAttribute === 'function') img.removeAttribute('srcset');
      img.src = img.dataset.fallbackSrc;
    }
  };
  const scheduleImageFallbacks = () => {
    setTimeout(() => view.querySelectorAll('img[data-fallback-src]').forEach(tryImageFallback), 3000);
  };
  const updateDesignActionState = () => {
    const actionButton = view.querySelector('[data-action="add-selected"], [data-action="continue-size"]');
    if (actionButton) actionButton.disabled = !state.selectedItemKeys.length;
  };
  const setFormLocked = (form, locked) => {
    if (!form) return;
    const controls = form.elements ? Array.from(form.elements) : typeof form.querySelectorAll === 'function' ? Array.from(form.querySelectorAll('input, select, textarea')) : [];
    controls.forEach(control => { control.disabled = locked; });
  };
  const updateSubmitState = (label = 'Submit Convention Order', message = '') => {
    const submitButton = view.querySelector('[data-action="submit"]');
    const backButton = view.querySelector('[data-action="back"]');
    const status = view.querySelector('[data-turnstile-status]');
    const submitLocked = Boolean(submissionInFlight || (pendingSubmissionForm && !submissionUncertain));
    const navigationLocked = Boolean(pendingSubmissionForm || submissionInFlight);
    if (submitButton) { submitButton.disabled = submitLocked; submitButton.textContent = label; }
    if (backButton) backButton.disabled = navigationLocked;
    if (status) { status.hidden = !message; status.textContent = message; }
  };
  const clearTurnstileWatchdog = () => {
    if (turnstileWatchdogId !== null && typeof clearTimeout === 'function') clearTimeout(turnstileWatchdogId);
    turnstileWatchdogId = null;
  };
  const resetTurnstileWidget = () => {
    if (turnstileWidgetId === null || !window.turnstile) return;
    try { window.turnstile.reset(turnstileWidgetId); } catch (_) {}
  };
  const removeTurnstileWidget = () => {
    clearTurnstileWatchdog();
    if (turnstileWidgetId !== null && window.turnstile) {
      try { window.turnstile.remove(turnstileWidgetId); } catch (_) {}
    }
    turnstileWidgetId = null;
  };
  const showTurnstileProblem = (message, form, attempt) => {
    if (attempt !== turnstileAttempt || pendingSubmissionForm !== form || submissionInFlight) return;
    const keepUncertainRequest = (submissionUncertain || retryingUncertainSubmission) && Boolean(pendingOrderRequest);
    clearTurnstileWatchdog();
    resetTurnstileWidget();
    turnstileAttempt += 1;
    if (keepUncertainRequest) {
      submissionUncertain = true;
      retryingUncertainSubmission = false;
      setFormLocked(form, true);
      updateSubmitState('Check again', message);
      return;
    }
    setFormLocked(form, false);
    pendingSubmissionForm = null;
    pendingOrderRequest = null;
    submissionUncertain = false;
    retryingUncertainSubmission = false;
    updateSubmitState('Submit Convention Order', message);
  };
  const showSubmissionUncertain = (form, attempt) => {
    if (attempt !== turnstileAttempt || pendingSubmissionForm !== form) return;
    resetTurnstileWidget();
    removeTurnstileWidget();
    submissionInFlight = false;
    submissionUncertain = true;
    retryingUncertainSubmission = false;
    setFormLocked(form, true);
    turnstileAttempt += 1;
    updateSubmitState('Check again', 'We could not confirm whether your order was created. Please do not submit a second order. Use Check again to retry this same request, or ask a staff member for help.');
  };
  const postOrder = async (form, request, token, attempt) => {
    const endpoint = root.dataset.submitEndpoint;
    try {
      const { response, text: responseText } = await fetchResponseWithTimeout(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(Object.assign({}, request, { turnstileToken: token })) }, submitTimeoutMs);
      let result;
      try { result = JSON.parse(responseText); } catch (_) { throw new Error('Invalid submission response.'); }
      if ((!response.ok || result.error) && !result.conventionOrderId) throw new Error('Order was not created.');
      if (!result.conventionOrderId) throw new Error('Missing Convention Order ID.');
      if (attempt !== turnstileAttempt || pendingSubmissionForm !== form) return;
      removeTurnstileWidget();
      submissionComplete = true; pendingSubmissionForm = null; pendingOrderRequest = null; submissionInFlight = false; submissionUncertain = false; retryingUncertainSubmission = false; turnstileAttempt += 1;
      submissionId = ''; submissionSignature = ''; shippingDraft = null;
      view.innerHTML = result.emailSent !== false
        ? `<section class="co-inline-confirmation" aria-live="polite"><img class="co-inline-confirmation__logo" src="https://www.liberoanime.com/cdn/shop/files/db3326dd239ea831d7e688b363dbd19f.png?v=1755193903&width=180" alt="Libero Art Studio" width="88" height="88"><h2>Thank you for your order.</h2><p>We have received your Convention Order. Please check your email for the confirmation message.</p><p class="co-inline-confirmation__reference">Your Convention Order ID: <strong>${esc(result.conventionOrderId)}</strong></p></section>`
        : `<section class="co-inline-confirmation" aria-live="polite"><h2>Your order was received.</h2><p>Your confirmation email is pending. Please save the order ID below and contact a staff member for assistance.</p><p class="co-inline-confirmation__reference">Your Convention Order ID: <strong>${esc(result.conventionOrderId)}</strong></p></section>`;
    } catch (error) {
      if (attempt !== turnstileAttempt || pendingSubmissionForm !== form) return;
      showSubmissionUncertain(form, attempt);
    }
  };
  const acceptTurnstileToken = (token, form, attempt) => {
    if (!token) { showTurnstileProblem('Verification failed. Please try again.', form, attempt); return; }
    if (attempt !== turnstileAttempt || pendingSubmissionForm !== form || !pendingOrderRequest || submissionInFlight || state.step !== 6 || !form.isConnected) return;
    clearTurnstileWatchdog();
    submissionUncertain = false;
    retryingUncertainSubmission = false;
    submissionInFlight = true;
    updateSubmitState('Submitting…');
    postOrder(form, pendingOrderRequest, token, attempt);
  };
  const renderTurnstileWidget = (api, container, form, attempt = null) => api.render(container, {
    sitekey: turnstileSitekey,
    action: 'convention_order_submit',
    execution: 'execute',
    appearance: 'always',
    retry: 'never',
    'refresh-expired': 'never',
    'refresh-timeout': 'never',
    callback: token => { if (attempt !== null) acceptTurnstileToken(token, form, attempt); },
    'expired-callback': () => { if (attempt !== null) showTurnstileProblem('Verification expired. Please try again.', form, attempt); },
    'timeout-callback': () => { if (attempt !== null) showTurnstileProblem('Verification timed out. Please try again.', form, attempt); },
    'error-callback': () => { if (attempt !== null) showTurnstileProblem('Verification failed. Please try again.', form, attempt); },
    'unsupported-callback': () => { if (attempt !== null) showTurnstileProblem('This browser cannot run verification. Please try another browser.', form, attempt); },
  });
  const prepareTurnstile = async form => {
    const container = view.querySelector('[data-turnstile-widget]');
    if (!container) return;
    try {
      const api = await loadTurnstile();
      if (state.step !== 6 || !form.isConnected || !container.isConnected || pendingSubmissionForm || submissionInFlight || turnstileWidgetId !== null) return;
      const widgetId = renderTurnstileWidget(api, container, form);
      if (state.step !== 6 || !form.isConnected || !container.isConnected || pendingSubmissionForm || submissionInFlight) { api.remove(widgetId); return; }
      turnstileWidgetId = widgetId;
    } catch (_) {
      if (state.step === 6 && form.isConnected && !pendingSubmissionForm && !submissionInFlight) {
        updateSubmitState('Submit Convention Order', 'Verification could not load. Submit to try again.');
      }
    }
  };
  const submit = async form => {
    if (!form.reportValidity()) return;
    if (!root.dataset.submitEndpoint || submissionInFlight || (pendingSubmissionForm && !submissionUncertain)) return;
    const container = view.querySelector('[data-turnstile-widget]');
    if (!container) return;
    const retryingUncertainRequest = submissionUncertain && pendingSubmissionForm === form && pendingOrderRequest && pendingOrderRequest.submissionId === submissionId;
    try {
      if (!retryingUncertainRequest) {
        const customer = Object.fromEntries(new FormData(form));
        if (customer.country === 'Other') customer.country = String(customer.countryOther || '').trim();
        delete customer.countryOther;
        const request = { customer, items: state.items.map(item => Object.assign({}, item)) };
        const signature = JSON.stringify(request);
        if (!submissionId || submissionSignature !== signature) { submissionId = createSubmissionId(); submissionSignature = signature; }
        pendingOrderRequest = Object.assign({ submissionId }, request);
      }
    } catch (_) {
      updateSubmitState('Submit Convention Order', 'Unable to prepare this order. Please refresh and try again.');
      return;
    }
    const attempt = ++turnstileAttempt;
    pendingSubmissionForm = form;
    retryingUncertainSubmission = retryingUncertainRequest;
    submissionUncertain = false;
    updateSubmitState('Verifying…', 'Verifying that you are human…');
    try {
      const api = await loadTurnstile();
      if (attempt !== turnstileAttempt || pendingSubmissionForm !== form || state.step !== 6 || !form.isConnected || !container.isConnected) return;
      if (turnstileWidgetId !== null) api.remove(turnstileWidgetId);
      turnstileWidgetId = null;
      const widgetId = renderTurnstileWidget(api, container, form, attempt);
      if (attempt !== turnstileAttempt || pendingSubmissionForm !== form || submissionInFlight) { api.remove(widgetId); return; }
      turnstileWidgetId = widgetId;
      api.execute(container);
      if (attempt === turnstileAttempt && pendingSubmissionForm === form && !submissionInFlight) {
        turnstileWatchdogId = setTimeout(() => showTurnstileProblem('Verification timed out. Please try again.', form, attempt), turnstileWatchdogTimeoutMs);
      }
    } catch (_) {
      showTurnstileProblem('Verification could not load. Please try again.', form, attempt);
    }
  };
  const render = () => {
    if (pendingSubmissionForm || submissionInFlight || submissionComplete) return;
    clearTurnstileWatchdog();
    turnstileAttempt += 1;
    pendingSubmissionForm = null;
    pendingOrderRequest = null;
    submissionInFlight = false;
    submissionUncertain = false;
    retryingUncertainSubmission = false;
    if (turnstileWidgetId !== null && window.turnstile) window.turnstile.remove(turnstileWidgetId);
    turnstileWidgetId = null;
    const previousForm = view.querySelector('[data-shipping-form]');
    if (previousForm) {
      // Keep address drafts in this page only, and exclude verification tokens.
      shippingDraft = Object.fromEntries(['name', 'email', 'phone', 'country', 'countryOther', 'address1', 'address2', 'city', 'state', 'postalCode']
        .map(name => [name, previousForm.elements.namedItem(name).value]));
    }
    setProgress();
    view.innerHTML = state.step === 1 ? renderGames() : state.step === 2 ? renderProducts() : state.step === 3 ? renderDesigns() : state.step === 4 ? renderSize() : state.step === 5 ? renderCart() : renderShipping();
    const shippingForm = view.querySelector('[data-shipping-form]');
    if (shippingForm && shippingDraft) Object.entries(shippingDraft).forEach(([name, value]) => { shippingForm.elements.namedItem(name).value = value; });
    updateCountryOther();
    scheduleImageFallbacks();
    if (state.step === 6) {
      const form = view.querySelector('[data-shipping-form]');
      if (form) prepareTurnstile(form);
    }
  };
  view.addEventListener('error', event => {
    const img = event.target;
    if (!(img instanceof HTMLImageElement)) return;
    if (!img.dataset.fallbackUsed && img.dataset.fallbackSrc && img.dataset.fallbackSrc !== img.src) {
      tryImageFallback(img);
      return;
    }
    if (!img.dataset.fallbackSrc || img.dataset.fallbackUsed) showImageFallback(img);
  }, true);
  view.addEventListener('click', event => {
    const game = event.target.closest('[data-game]'); const product = event.target.closest('[data-product]'); const item = event.target.closest('[data-item]'); const action = event.target.closest('[data-action]'); const remove = event.target.closest('[data-remove]');
    if (action && state.step === 6 && (pendingSubmissionForm || submissionInFlight) && action.dataset.action !== 'submit') return;
    if (game) { state.game = game.dataset.game; state.productType = ''; state.selectedItemKeys = []; state.pendingItems = []; state.selectedSize = ''; render(); } else if (product) { state.productType = product.dataset.product; state.selectedItemKeys = []; state.pendingItems = []; state.selectedSize = ''; render(); } else if (item) { const key = item.dataset.item; state.selectedItemKeys = state.selectedItemKeys.includes(key) ? state.selectedItemKeys.filter(value => value !== key) : [...state.selectedItemKeys, key]; item.classList.toggle('is-selected'); updateDesignActionState(); } else if (event.target.closest('[data-size]')) { state.selectedSize = event.target.closest('[data-size]').dataset.size; render(); } else if (remove) { state.items.splice(Number(remove.dataset.remove), 1); render(); } else if (action) {
      if (action.dataset.action === 'submit') { const form = action.closest('form') || view.querySelector('[data-shipping-form]'); if (form) submit(form); return; }
      if (action.dataset.action === 'retry-catalog') { loadCatalog(); return; }
      if (action.dataset.action === 'continue-game') state.step = 2;
      if (action.dataset.action === 'continue-product' && !productContinueDisabled()) state.step = 3;
      if (action.dataset.action === 'continue-size') { const selectedItems = selectedDesignItems(); if (!selectedItems.length) return; state.pendingItems = selectedItems; const defaultSize = (sizeOptions[state.productType] || []).find(option => option.default); state.selectedSize = defaultSize ? defaultSize.value : ''; state.step = 4; }
      if (action.dataset.action === 'add-sized') { if (!state.pendingItems.length || !state.selectedSize) return; addItemsToOrder(state.pendingItems, state.selectedSize); state.cartReturnStep = 4; state.step = 5; }
      if (action.dataset.action === 'add-selected') { const selectedItems = selectedDesignItems(); if (!selectedItems.length) return; addItemsToOrder(selectedItems); state.cartReturnStep = 3; state.step = 5; }
      if (action.dataset.action === 'add-more') { state.step = 1; state.productType = ''; }
      if (action.dataset.action === 'view-cart') { state.cartReturnStep = state.step; state.step = 5; }
      if (action.dataset.action === 'shipping') state.step = 6;
      if (action.dataset.action === 'restart') { state.step = 1; state.game = ''; state.productType = ''; state.items = []; state.selectedItemKeys = []; state.pendingItems = []; state.selectedSize = ''; submissionComplete = false; submissionId = ''; submissionSignature = ''; pendingOrderRequest = null; }
      if (action.dataset.action === 'back') {
        if (state.step === 6) state.step = 5;
        else if (state.step === 5) state.step = state.cartReturnStep || (needsSizeSelection() ? 4 : 3);
        else state.step = Math.max(1, state.step - 1);
      }
      render();
    }
  });
  view.addEventListener('change', event => { if (event.target.matches('select[name="country"]')) updateCountryOther(); });
  view.addEventListener('submit', event => { if (event.target.matches('[data-shipping-form]')) { event.preventDefault(); submit(event.target); } });
  let catalogLoadPromise = null;
  const loadCatalog = async () => {
    if (catalogLoadPromise) return catalogLoadPromise;
    state.catalogLoading = true;
    state.catalogError = false;
    render();
    catalogLoadPromise = (async () => {
      try {
        const { response, text: responseText } = await fetchResponseWithTimeout(catalogEndpoint, { credentials: 'same-origin', cache: 'no-store' }, catalogTimeoutMs);
        if (!response.ok) throw new Error('Catalog unavailable');
        let payload;
        try { payload = JSON.parse(responseText); } catch (_) { throw new Error('Catalog unavailable'); }
        const rows = Array.isArray(payload) ? payload : payload && payload.items;
        const nextCatalog = normalize(Array.isArray(rows) ? rows : []);
        if (!nextCatalog.length) throw new Error('Catalog unavailable');
        state.catalog = nextCatalog;
        state.selectedItemKeys = state.selectedItemKeys.filter(key => state.catalog.some(item => item.key === key));
      } catch (_) {
        state.catalogError = true;
      } finally {
        state.catalogLoading = false;
        catalogLoadPromise = null;
        render();
      }
    })();
    return catalogLoadPromise;
  };
  render();
  loadCatalog();
})();
